module.exports = __webpack_public_path__ + "img/social-lead-first-bg.42032494.png";